import { FunctionComponent, useState } from "react";
import { IProps, ITagReportChartFilter } from "./phrase-trigger-context.types";
import { defaultContext, PhraseTriggerContext } from "./phrase-trigger-context";

/**
 * A context provider for phrase trigger screen.
 * @param props.children The children that will have access to the phrase trigger context.
 * @param props.context  Context value to to be initialised with the provider.
 */
export const PhraseTriggerContextProvider: FunctionComponent<IProps> = ({ children, ...context }) => {
    const [filters, setFiltersState] = useState(context.filters ?? defaultContext.filters);

    const setFilters = (filters: ITagReportChartFilter) => {
        setFiltersState(filters);
    };

    return (
        <PhraseTriggerContext.Provider value={{ ...defaultContext, ...context, filters, setFilters }}>
            {children}
        </PhraseTriggerContext.Provider>
    );
};
